import { QueryBody } from "@api/internal/utils/types";

/**
 * Generates the payload for listing API requests based on the page type.
 * @param urlPath - The URL path of the listing page.
 * @param page - The current page number (for section pages).
 * @param size - The number of articles to fetch.
 * @param sections - The sections to filter articles by.
 * @param pageType - The type of the page (e.g., "keyword" or "section").
 * @param offset - The offset for pagination (for keyword pages).
 * @returns The payload object for the listing API request.
 */
export const getListingPayload = ({
  urlPath,
  page,
  size,
  sections,
  pageType,
  offset,
}: QueryBody): QueryBody => {
  const defaultPayload: QueryBody = {
    urlPath,
    size,
    sections,
  };

  if (pageType === "keyword") {
    return {
      ...defaultPayload,
      offset,
    };
  }

  return {
    ...defaultPayload,
    page,
  };
};

/**
 * Determines the appropriate listing API endpoint based on the page type.
 * @param pageType - The type of the page (e.g., "keyword" or "section").
 * @returns The API endpoint URL as a string.
 */
export const getListingEndpoint = (pageType?: string): string => {
  if (pageType === "keyword") return "/_plat/api/v1/articles/tags";

  return "/_plat/api/v1/articles/sections";
};
